<template>
  <el-dialog title="选择装修地点" :visible.sync="selectVisible" width="1250px" :show-close="true" class="text-center" append-to-body>
    <div class="content text-left flex h-100 bg-f3f4f7">
      <div id="moveLeftM" class="h-100 flex-column bg-ff menu" style="width: 200px">
        <div class="left-top">
          <div class="flex-1 font-16-30313a">客户分类</div>
        </div>
        <div class="flex-1 h-0" v-if="menuList && menuList.length">
          <div class="menuItem" v-for="(item, index) in menuList" :key="index" :class="{'activeItem': index === chooseMenuId}" @click="onChooseMenu(item)">
            <div class="index">{{index + 1}}</div>
            {{item.name}}
          </div>
        </div>
      </div>
      <div class="flex-1 flex-column w-0 ptb-10 plr-20">
        <div class="flex mb-10">
          <div class="title flex align-center bg-ff flex-1">
            <div class="decoration-line mr-5"></div>
            <div class="font-16-f5971d font-bold">客户列表</div>
          </div>
          <div class="flex ml-10">
            <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
              <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
              <el-input type="text" placeholder="用户名/装修地点/项目经理" v-model="keywords" clearable @keyup.enter.native="searchBtn"></el-input>
            </div>
            <button class="btn-30-bg-82b925" @click="searchBtn">搜索</button>
          </div>
        </div>
        <div class="flex-1 flex-column h-0">
          <erp-table ref="erpTable" :table-data="tableData" :loading="loading" :column-data="columnData" @on-choose="onChoose" :customs="[{field: 'customerAssign.pmName', visible: chooseMenuId === 0}, {field: 'address', visible: chooseMenuId === 1}]"></erp-table>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ErpTable from '../../../components/ErpTable'
import Pagination from '@/components/Pagination'
export default {
  name: 'SelectDecorationAddress',
  components: {ErpTable, Pagination},
  data () {
    return {
      selectVisible: false,
      menuList: [{
        name: '装修客户',
        id: 0
      }, {
        name: '零售客户',
        id: 1
      }],
      chooseMenuId: 0,
      keywords: null,
      loading: true,
      tableData: [],
      columnData: [{
        field: 'operate',
        title: '操作',
        width: '70',
        isDefine: true,
        child: [{
          className: 'btn-16-bd-85 btn-hover mr-5',
          title: '选择',
          methodName: 'on-choose',
          type: 'btn'
        }]
      }, {
        field: 'customerAddress',
        title: '客户名/装修地点',
        minWidth: '300'
      }, {
        field: 'customerAssign.pmName',
        title: '项目经理',
        minWidth: '300'
      }, {
        field: 'address',
        title: '地址',
        minWidth: '300'
      }],
      page: 1,
      limit: 10,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 10, // 当前页条数
      total: 100 // 总条数
    }
  },
  created () {},
  mounted () {},
  methods: {
    getData () {
      if (this.chooseMenuId === 0) {
        this.axios.post(`customer/queryForPage`, {
          companyId: this.$store.state.companyId,
          page: this.page,
          limit: this.limit,
          keywords: this.keywords,
          orderFlag: 1,
          status: 1
        }).then(res => {
          var reg = new RegExp('null', 'g')
          if (res.data.success) {
            res.data.data.list.forEach(i => {
              i.customerAddress = (i.name + '/' + i.detailedAddress).replace(reg, '')
            })
            this.tableData = res.data.data.list
            this.pageSize = res.data.data.pages
            this.pageNo = this.page
            this.pageTotal = res.data.data.size
            this.total = res.data.data.total
            this.loading = false
          }
        })
      } else {
        this.axios.post(`retailCustomer/queryForPage`, {
          companyId: this.$store.state.companyId,
          page: this.page,
          limit: this.limit,
          keywords: this.keywords,
          orderFlag: 1
        }).then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.list
            this.pageSize = res.data.data.pages
            this.pageNo = this.page
            this.pageTotal = res.data.data.size
            this.total = res.data.data.total
            this.loading = false
          }
        })
      }
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseMenuId) {
        this.chooseMenuId = menu.id
        this.getData()
      }
    },
    onChoose (row) {
      if (this.chooseMenuId === 0) {
        this.$parent.$parent.customerType = 1
        this.$parent.$parent.pmName = row.customerAssign.pmName
        this.$parent.$parent.pmId = row.customerAssign.pmId
        this.$parent.$parent.address = row.detailedAddress
      } else {
        this.$parent.$parent.customerType = 2
        this.$parent.$parent.address = row.address
      }
      this.$parent.$parent.customerId = row.id
      this.$parent.$parent.customerName = row.name
      this.$parent.$parent.customerName = row.name
      this.$parent.$parent.getOrderControl()
      this.$message({
        message: '选择成功',
        type: 'success'
      })
      this.selectVisible = false
    },
    searchBtn () {
      this.page = 1
      this.getData()
    },
    jump (page) {
      this.page = page
      this.getData()
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .content{
    height: 520px;
  }
  .menu{
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
  }
  .hide-x{
    box-shadow: none!important;
  }
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
  }
  .menuItem{
    height: 36px;
    font-size: 14px;
    color: #30313a;
    padding:  0 20px;
    display: flex;
    align-items: center;
    border-bottom: 1px dashed #e2e2e2;
    cursor: pointer;
    background: transparent;
  }
  .activeItem{
    color: #f5971d;
    background: #f9f9fb;
  }
  .index{
    width: 14px;
    height: 14px;
    background-color: #b9b9b9;
    border-radius: 4px;
    color: #fff;
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    margin-right: 5px;
  }
  .activeItem .index{
    background: #f5971d;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .content .title{
    height: 30px;
    padding-left: 10px;
    border-radius: 4px;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/SelectDecorationAddress.vue